export enum TableSortDirection {
  none = '',
  asc = 'asc',
  desc = 'desc',
}
